import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '@com-delta-idp/mnx-oauth';
import { EndpointKeys, Libraries } from '@com-delta-idp/mnx-skymiles-shared';
import {
  ApiBuilder,
  AppConfigService,
  CustomError,
  HttpRequestMethods,
  IDP_APPS,
  handleError,
  logCustomError
} from '@com-delta-idp/mnx-utils';
import { Observable, of, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { COMMON_HEADER_KEY, commonHeaderInfo } from '../../models';
import { EarnsSummaryResponse } from '../../models/api/earns-summary.interfaces';
import {
  CommonRequest,
  PayloadRequest
} from '../../models/api/tracker.interfaces';

@Injectable({
  providedIn: 'root'
})
export class EarnsSummaryService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private session: SessionService
  ) {}

  getEarnsSummary = (
    request: CommonRequest
  ): Observable<EarnsSummaryResponse | undefined> => {
    commonHeaderInfo['X-Delta-DLCOM_Loyalty_App_Test'] = COMMON_HEADER_KEY;
    commonHeaderInfo['Authorization'] = this.session.token.access_token;
    const payload: PayloadRequest = { carrierCode: request.carrierCode };
    if (payload.carrierCode) {
      return new ApiBuilder<PayloadRequest, EarnsSummaryResponse>(
        this.http,
        this.appConfig
      )
        .app(IDP_APPS.SKYMILES)
        .endpointKey(EndpointKeys['SKYMILES_API_EARNS_SUMMARY'])
        .method(HttpRequestMethods['POST'])
        .payload(payload)
        .httpHeaders(commonHeaderInfo)
        .timeOut(request.timeout)
        .retries(request.retry)
        .errorHandler(handleError.bind(this))
        .library(Libraries.OVERVIEW)
        .withCredentials(true)
        .create()
        .pipe(
          map((response: EarnsSummaryResponse | CustomError) => {
            return this.existCustomError(response);
          })
        );
    }
    return of(undefined);
  };

  existCustomError(
    response: EarnsSummaryResponse | CustomError
  ): EarnsSummaryResponse {
    if ('errorResponse' in response) {
      logCustomError(
        response.errorResponse,
        IDP_APPS.SKYMILES,
        Libraries.OVERVIEW,
        EndpointKeys.SKYMILES_API_EARNS_SUMMARY
      );
      throw throwError(response);
    }
    return response;
  }
}
